import React, { useState, useEffect } from "react";
import { Header, Footer } from "../components/common";
import {
  HeroSection,
  EmotionalSection,
  PackagesSection,
  WhyChooseUsSection,
  ServiceAreasSection,
  ReviewsSection,
  PoliciesSection,
  TradeSectionComingSoon,
  AccountBenefitsSection,
  FinalCTASection
} from "../components/home";
import { BookingModal, DiscountPopup } from "../components/booking";
import { useBooking } from "../context";

const HomePage = () => {
  const { setShowDiscountPopup, setPopupType } = useBooking();
  const [hasShownScrollPopup, setHasShownScrollPopup] = useState(() => {
    const lastShown = localStorage.getItem('rainxpress_popup_shown');
    if (lastShown) {
      const hoursSince = (Date.now() - parseInt(lastShown)) / (1000 * 60 * 60);
      return hoursSince < 24;
    }
    return false;
  });
  const [hasShownExitPopup, setHasShownExitPopup] = useState(() => {
    return sessionStorage.getItem('rainxpress_exit_popup_shown') === 'true';
  });

  // Show popup after scrolling (once per 24 hours)
  useEffect(() => {
    const handleScroll = () => {
      if (!hasShownScrollPopup && window.scrollY > window.innerHeight * 0.5) {
        setPopupType("normal_10");
        setShowDiscountPopup(true);
        setHasShownScrollPopup(true);
        localStorage.setItem('rainxpress_popup_shown', Date.now().toString());
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasShownScrollPopup, setShowDiscountPopup, setPopupType]);

  // Exit intent popup (once per session, only after scroll popup was dismissed)
  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && hasShownScrollPopup && !hasShownExitPopup) {
        setPopupType("exit_15");
        setShowDiscountPopup(true);
        setHasShownExitPopup(true);
        sessionStorage.setItem('rainxpress_exit_popup_shown', 'true');
      }
    };

    document.addEventListener("mouseleave", handleMouseLeave);
    return () => document.removeEventListener("mouseleave", handleMouseLeave);
  }, [hasShownScrollPopup, hasShownExitPopup, setShowDiscountPopup, setPopupType]);

  return (
    <div data-testid="home-page">
      <Header />
      <HeroSection />
      <EmotionalSection />
      <PackagesSection />
      <WhyChooseUsSection />
      <ServiceAreasSection />
      <ReviewsSection />
      <PoliciesSection />
      <TradeSectionComingSoon />
      <AccountBenefitsSection />
      <FinalCTASection />
      <Footer />
      <BookingModal />
      <DiscountPopup />
    </div>
  );
};

export default HomePage;
